import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { FiEdit2, FiEye, FiTrash2 } from 'react-icons/fi';
import { MdOutlineClose } from 'react-icons/md';
import { RiAlertFill } from 'react-icons/ri';
import columns from './columns';
import CustomModal from '../../components/common/CustomModal';
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance';
import toast from 'react-hot-toast';
import ChangePassword from './ChangePassword';
import { getRole } from '../../utils/cookies/cookies'
import PermissionForm from './Permission';

const Team = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [pages, setPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [isPasswordModelOpen, setIsPasswordModelOpen] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState('');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserPermission, setSelectedUserPermission] = useState(null);
  const [isPermissionModelOpen, setIsPermissionModelOpen] = useState(false);

  const role = getRole();

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('team/list', {
        page: pages,
        limit: limit,
      });
      if (response.status === 200) {
        const transformedData = response.data.result.docs.map((item) => ({
          ...item,
          actions: (
            <div className='flex items-center'>
              <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                <Link to={`view/${item._id}`}>
                  <FiEye className='w-4 h-4' />
                </Link>
              </div>
              <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                <Link to={`edit/${item._id}`}>
                  <FiEdit2 className='w-4 h-4' />
                </Link>
              </div>
              <div
                className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'
                onClick={() => handleOpenDeleteModal(item._id)}
              >
                <FiTrash2 className='w-4 h-4' />
              </div>

              {(role === 'admin') && (
                <>
                  <button
                    onClick={() => handleOpenPasswordDialog(item._id, item.full_name)}
                    className='text-white ml-2 bg-primary hover:bg-orange-600 rounded-md h-10 px-2 w-auto'
                  >
                    Change Password
                  </button>
                  {/* <button
                    onClick={() => handleOpenPermission(item)}
                    className='text-white mr-2 ml-3 bg-primary hover:bg-orange-600 rounded-md h-10 px-2 w-auto'
                  >
                    Add Permission
                  </button> */}
                </>
              )}
            </div>
          ),
        }));
        setData(transformedData);
        setTotalRows(response.data.result.totalDocs);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pages, limit]);

  const handleOpenDeleteModal = (id) => {
    setSelectedTeam(id);
    setIsModalOpen(true);
  };

  const handleOpenPasswordDialog = (userId, userName) => {
    setSelectedUserName(userName);
    setSelectedUserId(userId);
    setIsPasswordModelOpen(true);
  };

  const handleClosePasswordDialog = () => {
    setIsPasswordModelOpen(false);
    setSelectedUserName('');
    setSelectedUserId(null);
  };

  const handlePasswordSubmit = async (values) => {
    try {
      const response = await axiosAuthInstance.put(
        `team/admin-change-password`, { id: selectedUserId, password: values.password }
      );
      if (response.status === 200) {
        handleClosePasswordDialog();
      }
    } catch (error) {
      console.log('error :>> ', error);
    } finally {
      handleClosePasswordDialog();
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTeam(null);
  };

  const handlePageChange = (newPage) => {
    setPages(newPage);
  };

  const handleLimitPerPageChange = (newLimit) => {
    setLimit(newLimit);
    setPages(1);
  };

  const handleDelete = async () => {
    setIsDeleteLoading(true);
    try {
      const response = await axiosAuthInstance.delete(
        `team/delete/${selectedTeam}`,
      );
      if (response.status === 200) {
        fetchData();
        setIsDeleteLoading(false);
        setIsModalOpen(false);
      }
    } catch (error) {
      setIsDeleteLoading(false);
      setIsModalOpen(false);
    }
  };

  const handleOpenPermission = (userData) => {
    setSelectedUserPermission(userData)
    setIsPermissionModelOpen(true);
  };

  const handleClosePermissionDialog = () => {
    setIsPermissionModelOpen(false);
    setSelectedUserPermission(null);
  };

  return (
    <div>
      <div className='flex items-center justify-between border-b px-4 pb-2'>
        <h1 className='text-2xl'>Team</h1>
        <Link to='/team/add'>
          <button className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'>
            Add
          </button>
        </Link>
      </div>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[10, 20, 30]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitPerPageChange}
      />
      {isPasswordModelOpen && (
        <ChangePassword
          isOpen={isPasswordModelOpen}
          handleClose={handleClosePasswordDialog}
          handleSubmit={handlePasswordSubmit}
          name={selectedUserName}
          userId={selectedUserId}
        />
      )}

      {isModalOpen && (
        <CustomModal handleCloseModal={handleCloseModal}>
          <div className='p-4 relative'>
            <div
              className='absolute right-5 cursor-pointer hover:opacity-70'
              onClick={handleCloseModal}
            >
              <MdOutlineClose className='text-2xl' />
            </div>
            <div className='flex flex-col items-center justify-between gap-4'>
              <div className='flex flex-wrap justify-center alert-ico'>
                <RiAlertFill className='text-5xl' />
              </div>
              <h2>Are you sure you want to delete this Team?</h2>
              <div className='flex gap-4 mt-4'>
                <button
                  onClick={handleCloseModal}
                  className='bg-gray-300 px-4 py-2 rounded'
                >
                  No, Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className='bg-red-500 text-white px-4 py-2 rounded'
                >
                  {isDeleteLoading ? (
                    <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent' />
                  ) : (
                    "Yes, I'm sure"
                  )}
                </button>
              </div>
            </div>
          </div>
        </CustomModal>
      )}

      {isPermissionModelOpen && (
        <PermissionForm
          isOpen={isPermissionModelOpen}
          handleClose={handleClosePermissionDialog}
          user={selectedUserPermission}
        />
      )}
    </div>
  );
};

export default Team;

